const START_ADD_INDEX = 'introduction/START_ADD_INDEX';
const STOP_ADD_INDEX = 'introduction/STOP_ADD_INDEX';
const ADD_INDEX = 'introduction/ADD_INDEX';

const SELECT_DATA = 'introduction/SELECT_DATA';

const SET_POSITION = 'introduction/SET_POSITION';

export default {
  START_ADD_INDEX,
  ADD_INDEX,
  SELECT_DATA,
  SET_POSITION,
  STOP_ADD_INDEX
};



// WEBPACK FOOTER //
// ./src/state/introduction/types.js